import { Dialog, DialogContent } from '@repo/videa-components/src/ui/dialog';
import { useAtom } from 'jotai';

import { isPreviewOpenAtom } from '../../../multiFileViewer/imageToolbar/atoms';
import { usePatientPrintoutData } from '../hooks/usePatientPrintoutData';

import { QRPrintDownloadContent } from './QRPrintDownloadContent';

export const PreviewDialog = () => {
  const [isPreviewOpen, setIsPreviewOpen] = useAtom(isPreviewOpenAtom);

  const { visitSummaryResponse } = usePatientPrintoutData();

  return (
    <Dialog open={isPreviewOpen} onOpenChange={setIsPreviewOpen}>
      <DialogContent
        className="!vai-p-0 vai-max-w-[calc(100%-64px)] vai-overflow-hidden"
        closeClassName="vai-text-white"
      >
        <div className="vai-max-h-[90vh] vai-bg-background-dark">
          <QRPrintDownloadContent
            isLoading={visitSummaryResponse?.isLoading}
            visitSummaries={visitSummaryResponse?.data}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
